import type { ErrorEvent } from "@sentry/react";
// FS-2026-065: retain source locations, never application payloads or error values.
export function minimalErrorEvent(event: ErrorEvent): ErrorEvent {
  const cleanUrl = (value?: string) => value?.split(/[?#]/)[0];
  return {
    type: event.type,
    event_id: event.event_id,
    timestamp: event.timestamp,
    platform: event.platform,
    level: event.level,
    release: event.release,
    environment: event.environment,
    exception: {
      values: event.exception?.values?.map((item) => ({
        type: item.type,
        value: "Client-side error",
        stacktrace: {
          frames: item.stacktrace?.frames?.map((frame) => ({
            filename: cleanUrl(frame.filename),
            function: frame.function,
            lineno: frame.lineno,
            colno: frame.colno,
            in_app: frame.in_app,
          })),
        },
      })),
    },
    breadcrumbs: [],
  };
}
